
import i18n from '@/i18n';
import Vue from 'vue';
import { TimelineItem, FileUploadBox, FileDownloadBox } from '@descomplica/vue-components';
import { MAX_ALLOWED_FILESIZE } from '@/helpers/upload';
import { getFilenameFromUrl } from '@/helpers/url';

export interface FileTCC {
  isUploadReady: boolean;
  errorMessage: string;
  name: string;
  dataUrl: string;
}

export default Vue.extend({
  components: {
    TimelineItem,
    FileUploadBox,
    FileDownloadBox,
  },
  props: {
    hasSentFinalTcc: {
      type: Boolean,
      required: true,
    },
    filesLink: {
      type: String,
      required: true,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  data(): any {
    return {
      maxFileSize: MAX_ALLOWED_FILESIZE / 2,
      finalTCCFile: {
        isUploadReady: false,
        errorMessage: '',
        name: '',
        dataUrl: '',
      },
      quizFile: {
        isUploadReady: false,
        errorMessage: '',
        name: '',
        dataUrl: '',
      },
    };
  },
  computed: {
    filename(): string {
      return this.filesLink ? getFilenameFromUrl(this.filesLink) : '';
    },
  },
  methods: {
    documentUploadHandler(file: File, key: string) {
      this[key].errorMessage = '';
      this[key].name = file.name;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this[key].dataUrl = reader.result as string;
      };

      this[key].isUploadReady = true;
    },
    documentDeleteHandler(key: any) {
      this[key].name = '';
      this[key].dataUrl = '';
      this[key].errorMessage = '';
      this[key].isUploadReady = false;
    },
    errorHandler(err: 'type' | 'size', key: any) {
      this[key].errorMessage = i18n.t(`yourAssessments.tcc.tabs.finalThesis.preUploadError.${err}`);
    },
    submit(): void {
      if (this.finalTCCFile.isUploadReady && this.quizFile.isUploadReady)
        this.$emit('sendFinalTCC', this.finalTCCFile, this.quizFile);
    },
    download(): void {
      this.$emit('downloadFinalTCC');
    },
  },
});
